import React, { useState } from 'react';
import ReactCardFlip from 'react-card-flip';
import {
  GalleryContainer,
  GalleryWrapper,
  GalleryCard,
  GalleryIcon,
  GalleryH2,
  GalleryH1,
  CardDescr,
  CardDescrItem,
} from './Gallery';

import Img1 from '../../images/img5.png';
import Img2 from '../../images/img2.jpg';
import Img3 from '../../images/img3.jpg';
import Img4 from '../../images/img4.jpg';

const Gallery = () => {
  const [isFlipped, setIsFlipped] = useState(false);
  const handleClick = (event) => {
    event.preventDefault();
    setIsFlipped(!isFlipped);
  };
  return (
    <GalleryContainer id="gallery">
      <GalleryH1>Примеры наших работ</GalleryH1>
      <GalleryWrapper>
        <GalleryCard
          onClick={handleClick}
          onMouseEnter={handleClick}
          onMouseLeave={handleClick}
        >
          <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
            <GalleryIcon src={Img1}></GalleryIcon>
            <CardDescr>
              <CardDescrItem>Зеркала в багетной раме</CardDescrItem>
              <CardDescrItem>Зеркала с фацетом</CardDescrItem>
              <CardDescrItem>
                Зеркало в ванную/ванную/ детскую/коридор
              </CardDescrItem>
              <CardDescrItem>Зеркала в багетной раме</CardDescrItem>
            </CardDescr>
          </ReactCardFlip>
          <GalleryH2>Мебель из стекла</GalleryH2>
        </GalleryCard>
        <GalleryCard>
          <GalleryIcon src={Img2}></GalleryIcon>
          <GalleryH2>Лестницы и элементы интерьера</GalleryH2>
        </GalleryCard>
        <GalleryCard>
          <GalleryIcon src={Img3}></GalleryIcon>
          <GalleryH2>Душевые и сауны</GalleryH2>
        </GalleryCard>
        <GalleryCard>
          <GalleryIcon src={Img4}></GalleryIcon>
          <GalleryH2>Зеркала</GalleryH2>
        </GalleryCard>
      </GalleryWrapper>
    </GalleryContainer>
  );
};

export default Gallery;
